/* eslint-disable-next-line import/no-unresolved */
import 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.5.1/dist/confetti.browser.min.js'

class AdventCalendarDrawer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.moveDelay = 0.1
    this.moveDuration = 1.5
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('advent:drawer', this.setDrawerContent.bind(this))

    this.els['offer-form']?.elements.forEach(form => {
      this.listeners.add(form, 'submit', this.onOfferFormSubmit.bind(this))
    })
  }

  setDrawerContent (event) {
    this.els.title.element.innerText = event.detail.title

    this.els.offer.elements.forEach(offer => {
      offer.setAttribute(
        'aria-hidden',
        parseInt(offer.dataset.index, 10) ===
          parseInt(event.detail.selectedDay, 10)
          ? 'false'
          : 'true',
      )
    })

    setTimeout(
      () => this.setAttribute('data-loading', 'true'),
      event.detail.targetIndex === event.detail.currentIndex
        ? 0
        : (this.moveDelay + this.moveDuration) * 1000,
    )

    setTimeout(
      () => this.removeAttribute('data-loading'),
      event.detail.targetIndex === event.detail.currentIndex
        ? 2100
        : (this.moveDelay + this.moveDuration) * 1000 + 2100,
    )
  }

  async onOfferFormSubmit (event) {
    event.preventDefault()

    const formData = new FormData(event.target)

    const url = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe'
    const email = formData.get('email')
    const listId = formData.get('list_id')

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        'cache-control': 'no-cache',
      },
      mode: 'cors',
      body: new URLSearchParams({
        g: listId,
        email,
      }),
    }).then(response => response.json())

    if (response.success) {
      this.els['offer-email'].element.remove()
      this.els['offer-button'].element.textContent =
        window.theme.strings.entered
      this.els['offer-button'].element.disabled = true
      this.setCartAttribute(listId)

      /* eslint-disable-next-line no-undef */
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { x: 0.5, y: 0.5 },
      })

      setTimeout(() => {
        this.querySelector('[data-drawers-close]').click()
      }, 3000)
    }
  }

  async setCartAttribute (listId) {
    await window.BAO.Cart.updateCartAttributes({
      [listId]: listId,
    })
  }
}

if (!customElements.get('advent-calendar-drawer')) {
  customElements.define('advent-calendar-drawer', AdventCalendarDrawer)
}
